import localStorageUtil from 'helpers/localStorageUtil';
import tooltip from 'helpers/tooltip';
import modal from 'helpers/modal';
import template from '../../templates/payrollHistory/Item.ejs';
import PickupDateModal from '../../views/payrollHistory/PickupDateModal.js';
import SendPayslipsModal from '../../views/payrollHistory/SendPayslipsModal.js';
import Download from 'downloadjs';
import Alerts from 'lib/alerts';
import loader from 'helpers/loader';
import moment from 'moment';
import Decimal from 'decimal.js';

module.exports = Backbone.View.extend({
    className: 'col-lg-6',

    events: {
        'click .js-cancel-payroll': 'cancel',
        'click .js-set-date': 'setDate',
        'click .js-download-payroll': 'download',
        'click .js-send-payslips': 'sendPayslips',
        'click .js-finish-payroll': 'finish',
        'click .js-sync': 'sync'
    },

    initialize: function(options) {
        this.options = Object.assign(
            {attachments: null, integration: null},
            options || {}
        );

        if (this.model.get('paymentType') === '2') {
            this.pickupDateModal = new PickupDateModal();
        }
        this.sendPayslipsModal = new SendPayslipsModal();

        this.model.on('change', this.render, this);

        if (!this.options.integration) {
            return this.render();
        }

        this.model.fetchIntegrations({filter: {
            where: {integrationId: this.options.integration.id},
            limit: 1
        }}).then(() => this.render());
        return this;
    },

    render: function() {
        var archive = this.options.attachments
            .findByTags(['payroll', 'archive', 'ready']).first();

        this.$el.html(template({
            company:     app.company,
            model:       this.model,
            summaryPdf:  this.options.attachments
                .findByTags(
                    ['payroll', 'pdf'],
                    ['form', 'receipt', 'upload']
                ).first(),
            summaryXls:  this.options.attachments
                .findByTags(
                    ['payroll', 'xls'],
                    ['form', 'receipt', 'upload']
                ).first(),
            archive:     archive,
            payslipsPdf: this.options.attachments
                .findByTags(['payslip', 'list', 'pdf']).first(),
            receipts:    this.options.attachments
                .findByTags(['tax-receipt', 'upload']),
            showFinishButton: (
                this.model.get('status') === 3 &&
                app.company.get('mppAdminId')
            ),
            showSyncButton: (
                this.options.integration &&
                this.model.get('status') === 9
            ),
            integrationProvider:
                this.options.integration &&
                this.options.integration.get('provider') === 'xero' ?
                    'Xero' : 'Quickbooks',
            lastSyncAt: (
                this.model.getIntegrations().length ?
                    moment(
                        this.model.getIntegrations().first().get('syncedAt')
                    ).format('DD/MM/YYYY') :
                    ''
            ),
            pcb: new Decimal(this.model.get('mtd') || 0).plus(this.model.get('cp38') || 0).toDP(2, Decimal.ROUND_HALF_UP).toFixed(2),
            epf: new Decimal(this.model.get('employerEpf') || 0).plus(this.model.get('employeeEpf') || 0).toDP(2, Decimal.ROUND_HALF_UP).toFixed(2),
            socso: new Decimal(this.model.get('employerSocso') || 0).plus(this.model.get('employeeSocso') || 0).toDP(2, Decimal.ROUND_HALF_UP).toFixed(2),
            eis: new Decimal(this.model.get('employerEis') || 0).plus(this.model.get('employeeEis') || 0).toDP(2, Decimal.ROUND_HALF_UP).toFixed(2),

        }));

        tooltip.init(this);

        return this;
    },

    cancel: function() {
        modal.confirm({
            text:                'You will not be able to recover this payroll',
            confirmButtonText:   'Yes, Cancel Payroll',
            customClass:         'sweet-alert-error',
            closeOnConfirm:      false,
            showLoaderOnConfirm: true,
            callback: confirm => {
                if (!confirm) {
                    return;
                }

                this.model.destroy().then(() => {
                    localStorageUtil.removeItem('unsavedPayroll');
                    this.trigger('deleted');
                    this.undelegateEvents();
                    this.remove();
                    this.cancelSuccess();
                }, err => modal.error({text: err}));
            }
        });
    },

    cancelSuccess: function() {
        modal.success({
            title: 'Payroll Cancelled!',
            text:  'Your Payroll has been cancelled.'
        });
    },

    setDate: function() {
        this.pickupDateModal.setModel(this.model);
        this.pickupDateModal.render();
        this.pickupDateModal.show();
        return false;
    },

    download: function() {
        var archive = this.options.attachments
            .findByTags(['payroll', 'archive', 'ready']).first();

        if (archive) {
            /* jQuery ajax cannot be used here because messes up the response */
            var xhr = new XMLHttpRequest();
            xhr.open('GET', archive.getUrl(), true);
            xhr.responseType = 'blob';
            xhr.onload = function() {
                // TODO: handle errors
                // Alternatively we could use the whatwg-fetch polyfill
                if (this.status == 200) {
                    // get binary data as a response
                    var blob = this.response;
                    Download(blob, archive.get('name'), 'application/zip');
                }
            };
            xhr.send();
        } else {
            Alerts.show('infoConfirm', {
                title: 'File nearly ready!',
                html: 'Your Payroll zip that contains all your ' +
                'payroll files is being processed and should be ready ' +
                'shortly. It usually takes a few seconds or a minute at busy ' +
                'periods. Close this popup and refresh the page to see if ' +
                'it is ready',
                confirmButtonText: 'OK',
                showCancelButton: false
            });
        }
    },

    sendPayslips: function() {
        return this.model.fetchPayslips().then(payslips => {
            return Promise.all(
                payslips.map(payslip => payslip.fetchEmployee())
            ).then(() => payslips);
        }).then(payslips => {
            this.sendPayslipsModal.setModel(this.model);
            this.sendPayslipsModal.setCollection(payslips);
            this.sendPayslipsModal.render();
            this.sendPayslipsModal.show();
            return false;
        });
    },

    finish: function(ev) {
        let stopLoader = loader.startFullScreen(ev.currentTarget);

        return this.model.finish().then(() => {
            Alerts.show('infoConfirm', {
                title: 'Payroll Being Processed',
                html: `Your Payroll is being processed. You will receive ` +
                    `an email when it's ready.`,
                confirmButtonText: 'OK',
                showCancelButton: false
            });

        }).catch(() => {
            Alerts.show('infoConfirm', {
                title: 'Error while finishing payroll!',
                confirmButtonText: 'OK',
                showCancelButton: false
            });
        }).finally(stopLoader);
    },

    sync: function(ev) {
        let stopLoader = loader.startFullScreen(ev.currentTarget);

        this.model.syncPayroll(this.options.integration)
            .then(() => this.model.fetchIntegrations({filter: {
                where: {integrationId: this.options.integration.id},
                limit: 1
            }}))
            .then(() => {
                Alerts.show('infoConfirm', {
                    title: 'Payroll Synced',
                    html: `Your Payroll has been successfully synced!`,
                    confirmButtonText: 'OK',
                    showCancelButton: false
                });

                this.render();
            })
            .catch(err => {
                err || (err = {});
                let title = 'Unknown synchronization error';
                let msg = 'Please try again shortly';

                const errorMsg = typeof err.message === 'string' ?
                    JSON.parse(err.message) : (err.message || {});

                if (this.options.integration.get('provider') === 'quickbooks') {
                    title = 'QuickBooks error';
                    if (
                        typeof errorMsg.error === 'object' &&
                        typeof errorMsg.error.Fault !== 'undefined' &&
                        typeof errorMsg.error.Fault.Error !== 'undefined'
                    ) {
                        msg = '<ul class="text-left">';
                        msg += errorMsg.error.Fault.Error
                            .map(qbErr => ('<li>' + qbErr.Detail + '</li>'))
                            .join('');
                        msg += '</ul>';
                        msg += `<br>Possible causes are erroneous mappings to\
                            the chart of accounts.
                            Please review your settings before trying to sync\
                            again. \
                            If the error persists, don’t hesitate to contact\
                            our support team via chat or email.`;
                    } else {
                        msg = errorMsg;
                    }
                }

                // added xero errors
                // TODO change all this!
                if (this.options.integration.get('provider') === 'xero') {
                    if (
                        typeof errorMsg.error &&
                        errorMsg.error.length > 0
                    ) {

                        title = 'Xero mapping error';
                        msg = 'Missing items: <br /><br />';
                        msg += errorMsg.error.join('<br />');
                    } else if (typeof errorMsg.error === 'string') {
                        title = 'Xero authentication error';
                        msg = errorMsg.error;
                    }
                }

                Alerts.show('error', {title: title, html: msg});
            })
            .finally(stopLoader);
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payrollHistory/Item.js